import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
    console.log('Initializing Sentry...')

    Sentry.init({
        app: nuxtApp.vueApp,
        dsn: useRuntimeConfig().public.sentryDsn,
        environment: process.env.NODE_ENV || 'development',
        integrations: [],
        tracesSampleRate: 1.0,
        debug: true,
    })

    console.log('Sentry initialized!')
})
